export const isFetching = state => state.event.emailMergeTags.fetching;
export const mergeTags = state => state.event.emailMergeTags.emailMergeTags;
export const messagePreviews = state => state.event.emailMergeTags.previews;
